import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import * as Template from "../../templates";
import * as actions from "../../actions";

export default () => {
  const moduleName = `wholesales`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [name, setName] = useState(``);
  const [weight, setWeight] = useState(``);
  const [numbers, setNumbers] = useState(``);

  const [price, setPrice] = useState(``);
  const [categoryId, setCategoryId] = useState(``);
  const [categories, setCategories] = useState(``);

  const [submitted, setSubmitted] = useState(false);
 
  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (appReducer.wholesales_edit != undefined && id != undefined) {
      let row = appReducer.wholesales_edit.data;
      setName(row.name);
      setWeight(row.weight)
      setNumbers(row.numbers)
      setPrice(row.price);
      setCategoryId({
        value: row.product_price_id,
        label: `${row.product_price.product.name} - ${row.product_price.name} - ${row.product_price.code}`,
      });
    }
  }, [appReducer.wholesales_edit]);

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.wholesales_store != undefined && appReducer.wholesales_store.error == false) ||
        (appReducer.wholesales_update != undefined && appReducer.wholesales_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.wholesales_store,
    appReducer.wholesales_update
  ])

  useEffect(() => {
    dispatch(actions.list("product_prices/option"));
  }, []);

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  useEffect(() => {
    if (appReducer.product_prices_option_list != undefined) {
      setCategories(appReducer.product_prices_option_list.data);
    }
  }, [appReducer.product_prices_option_list]);

  const onChange = (value) => setCategoryId(value);

  return <Template.Form>
    <Template.SingleSelect
      withLabel
      required
      placeholder="گروه محصول"
      name="product_price_id"
      value={categoryId}
      onChange={onChange}
      options={categories}
    />
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.Input required value={weight} label="وزن" name="weight" type="text" />
    <Template.Input required value={numbers} label="تعداد در هر کارتن" name="numbers" type="number" />
    <Template.Input required value={price} label="قیمت پایه(تومان)" name="price" type="text" />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};